import * as React from 'react';

import { ListDetailStyles } from './ListDetailStyles';
import { ListDetailToolbarProps } from './types';

export interface ListDetailToolbarComponentProps extends ListDetailToolbarProps {
  testId?: string;
}

/**
 * Toolbar component for ListDetailLayout
 * Renders content-specific controls at beginning or end positions
 */
export const ListDetailToolbar: React.FC<ListDetailToolbarComponentProps> = ({
  toolbarVisibility,
  toolbarContentSpecificControls,
  testId = 'list-detail-toolbar',
}) => {
  if (toolbarVisibility === 'hidden') {
    return null;
  }

  const hasBeginningControls = toolbarContentSpecificControls?.beginning;
  const hasEndControls = toolbarContentSpecificControls?.end;

  if (!hasBeginningControls && !hasEndControls) {
    return null;
  }

  return (
    <div
      data-tb-test-id={testId}
      className={ListDetailStyles.ToolbarContainer}
    >
      <div className={ListDetailStyles.ToolbarControlsGroup}>
        {hasBeginningControls && toolbarContentSpecificControls.beginning}
      </div>
      <div className={ListDetailStyles.ToolbarControlsGroup}>
        {hasEndControls && toolbarContentSpecificControls.end}
      </div>
    </div>
  );
};

ListDetailToolbar.displayName = 'ListDetailToolbar';
